import { IQuestion } from 'constants/types';
import clsx from 'clsx';
import Image from 'next/image';
import { formatCreatedAtDate } from 'utils/formatDays';
import styles from './styles.module.css';
import Link from 'next/link';
import { Routes } from 'constants/routes';
import { Icon } from 'common/icon';

interface BlogPublicationProps {
  data: IQuestion;
  onReplyClick?: (reply: IQuestion) => void;
  isActive?: boolean;
}

export const Card = ({
  data,
  onReplyClick,
  isActive,
}: BlogPublicationProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>{data.title}</h1>

        <div className={styles.metaContainer}>
          <Link
            href={Routes.publicProfile(data?.user?._id)}
            className={styles.meta}
          >
            <div className={styles.author}>
              <Image
                src={data?.user.imageUrl ?? ''}
                alt={'author-image'}
                width={30}
                height={30}
                className={styles.avatar}
              />
              <span className={styles.authorName}>{data?.user.username}</span>
            </div>

            <div className={styles.divider} />

            <div className={styles.category}>
              {data?.category === 'News' && <Icon.NewsSecond />}
              {data?.category === 'Casino complaint' && <Icon.Complaints />}
              {data?.category === 'Topics' && <Icon.Question />}
              {data?.category === 'Other' && <Icon.Circle />}
              {!data?.category?.length && <Icon.Circle />}
              <span>{data?.category ?? 'Other'}</span>
            </div>

            <div className={styles.divider} />

            <span className={styles.date}>
              created on {formatCreatedAtDate(data.createdAt)}
            </span>
          </Link>

          <div className={styles.dividerReply} />

          {onReplyClick && (
            <div
              className={clsx(styles.replyButton, {
                [styles.replyButtonActive]: isActive,
              })}
              onClick={() => onReplyClick(data)}
            >
              <Icon.ArrowStraight />
              <span>{'Reply'}</span>
            </div>
          )}
        </div>

        <p className={styles.content}>{data.message}</p>
      </div>
    </div>
  );
};
